import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

/**
 * 社区许愿墙（任务墙）物业Web端 数据封装API
 * 后端服务编码统一走 /app/taskWall.* ，发布任务走统一支付 /app/payment.unifiedPayment
 * add by java110 team
 */

// 任务状态机（与后端 TaskWallDto 保持一致）
export const TASK_STATE = {
  WAIT_PAY: '1000', // 待支付
  WAIT_ACCEPT: '2000', // 待接单（已支付，报酬已托管）
  DOING: '3000', // 进行中（已被接单）
  WAIT_CONFIRM: '4000', // 待发布者确认
  PLATFORM_AUDIT: '5000', // 平台审核中
  FINISH: '6000', // 已完成
  CANCEL: '7000' // 已取消
}

// 任务状态名称映射
export const TASK_STATE_NAME = {
  '1000': '待支付',
  '2000': '待接单',
  '3000': '进行中',
  '4000': '待确认',
  '5000': '平台审核中',
  '6000': '已完成',
  '7000': '已取消'
}

// 任务日志动作名称映射
export const TASK_ACTION_NAME = {
  publish: '发布并支付',
  accept: '接单',
  update: '修改任务',
  cancel: '取消任务',
  submit: '完成提交',
  confirm: '确认完成',
  toAudit: '转平台审核',
  platformConfirm: '平台确认',
  pay: '打款'
}

// 获取任务状态名称
export function getTaskStateName(state) {
  return TASK_STATE_NAME[state] || '未知'
}

// 获取日志动作名称
export function getTaskActionName(action) {
  return TASK_ACTION_NAME[action] || action
}

/**
 * 根据照片地址拼接可访问的下载地址
 * 兼容：已是完整 http 地址直接返回；否则按 fileId 走下载组件
 */
export function buildTaskPhotoUrl(fileId) {
  if (!fileId) {
    return ''
  }
  if (fileId.indexOf('http') === 0) {
    return fileId
  }
  return '/callComponent/download/getFile/file?fileId=' + fileId + '&communityId=-1'
}

// 查询许愿墙任务列表（任务广场/我发布的/我接的）
export function listTaskWall(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/taskWall.listTaskWall',
      method: 'get',
      params: {
        ...params,
        communityId: params.communityId || getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询许愿墙任务详情（含照片、日志）
export function getTaskWallDetail(taskId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/taskWall.getTaskWall',
      method: 'get',
      params: { taskId }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 接单
export function acceptTaskWall(data) {
  return postTaskWall('/taskWall.acceptTaskWall', data)
}

// 完成提交（接单人上传凭证照片），photos 为照片地址数组
export function submitTaskWall(data) {
  return postTaskWall('/taskWall.submitTaskWall', data)
}

// 发布者确认完成（放款）
export function confirmTaskWall(data) {
  return postTaskWall('/taskWall.confirmTaskWall', data)
}

// 取消任务（仅未接单可取消，自动退款）
export function cancelTaskWall(data) {
  return postTaskWall('/taskWall.cancelTaskWall', data)
}

// 修改任务（仅未接单可改，不允许改报酬）
export function updateTaskWall(data) {
  return postTaskWall('/taskWall.updateTaskWall', data)
}

/**
 * 发布任务并支付（统一支付接口，business 固定为 taskWall）
 * 物业Web端使用 NATIVE 扫码支付，返回 {code, msg, codeUrl}
 * code=100 演示环境/0元直接成功；code=0 需展示 codeUrl 二维码扫码支付
 */
export function publishTaskWallPay(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.unifiedPayment',
      method: 'post',
      data: {
        ...data,
        communityId: data.communityId || getCommunityId()
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 统一的操作类 POST 请求封装
function postTaskWall(url, data) {
  return new Promise((resolve, reject) => {
    request({
      url,
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
